import dashify from "dashify";
import { createNamespacedHelpers } from "vuex";

const { mapState, mapMutations } = createNamespacedHelpers("activitySummary");

export default {
  props: ["entity"],
  data() {
    return {
      id: `input-${this.entity.id}`,
      name: dashify(this.entity.label),
      value:
        this.entity.field.type === "picklist"
          ? this.entity.field.options.find((o) => o.default)
          : this.entity.field.defaultValue,
      maxlength: this.entity.field.length,
      showError: false,
      readonly: this.entity.readOnly || false,
    };
  },
  computed: {
    ...mapState(["activity", "fieldErrors"]),
    existingValue() {
      const field =
        this.activity.data &&
        this.activity.data.find((field) => field.id === this.entity.field.id);
      return field ? field.value : this.value;
    },
    error() {
      return this.fieldErrors[this.entity.id];
    },
    required() {
      return this.entity.required && !this.activity.isInternal;
    },
  },
  watch: {
    value(value) {
      this.handleValue(value);
    },
  },
  created() {
    this.$_activitySummary_config.EventBus.$on(
      "ACTIVITY_FORM_SUBMITTED",
      () => {
        this.showError = true;
      }
    );

    this.$_activitySummary_config.EventBus.$on("UPDATED_INTERNAL_INPUT", () => {
      this.handleValue(this.value);
    });

    this.value === this.existingValue
      ? this.handleValue(this.value)
      : (this.value = this.existingValue);
  },
  methods: {
    ...mapMutations(["upsertFieldData"]),
    handleValue(value) {
      this.showError = false;
      this.upsertFieldData({
        id: this.entity.id,
        value: this.typecast(value),
        error: this.validate(value),
      });
    },
    typecast(value) {
      return value;
    },
    validate(value) {
      if (this.required && !value) {
        return "Please enter a value";
      }
      return null;
    },
  },
};



// WEBPACK FOOTER //
// ./~/vue-components/activity-summary/components/custom-section/fields/field.js